import { EntityRefLink } from '@backstage/plugin-catalog-react';
import React from 'react';
import { Box, CardHeader } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';
import { CardIcon } from '../CardIcon';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { useAnalytics } from '@backstage/core-plugin-api';

export declare type CatalogEntity = Entity & {
  icon: string;
};

export interface CardTitleOptions {
  defaultKind?: string;
  defaultIcon?: any;
  alwaysShowPagination?: boolean;
  hideIcons?: boolean;
}

export interface CardTitleProps {
  entity: Entity;
  options?: CardTitleOptions;
  style?: React.CSSProperties;
  title?: string;
}

export const CardTitle = ({
  entity,
  options,
  style,
  title,
}: CardTitleProps) => {
  const finalTitle = title ?? entity.metadata.title ?? entity.metadata.name;
  const analytics = useAnalytics();

  return (
    <Box display="flex" alignItems="center">
      <Box>
        <CardHeader
          style={{ padding: 0, ...style }}
          title={
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {!options?.hideIcons && (
                <CardIcon entity={entity} options={options!} />
              )}
              <EntityRefLink
                entityRef={entity}
                defaultKind={options?.defaultKind || 'Component'}
                onClick={() => {
                  analytics.captureEvent('click', 'catalog_item', {
                    attributes: {
                      event_category: 'click',
                      event_label: 'catalog_item',
                      value: stringifyEntityRef(entity),
                      entityRef: stringifyEntityRef(entity),
                    },
                  });
                }}
                title={finalTitle}
              />
            </Box>
          }
        />
      </Box>
    </Box>
  );
};
